import {client, JmapDataSource, modules, router} from "@intermesh/groupoffice-core";
import {Main} from "./Main";
import {BaseEntity, DateTime, EntityID, t, translate} from "@intermesh/goui";

modules.register({
	package: "business",
	name: "kanban",
	entities: [
		{
			name: "Board"
		},
		{
			name: "Column"
		},
		{
			name: "Card"
		}
	],
	async init() {
		let kanban: Main;
		client.on("authenticated", ({session}) => {
			if (!session.capabilities["go:business:kanban"]) {
				return;
			}

			router.add(/^kanban\/(\d+)$/, (boardId) => {
				modules.openMainPanel("kanban");
				kanban.load(boardId);
			});

			translate.setDefaultModule("business", "kanban");

			modules.addMainPanel("business", "kanban", "kanban", t("Kanban"), () => {
				kanban = new Main();
				return kanban;
			});
		});
	}
});

export interface Board extends BaseEntity {
	id: string,
	name: string,
	retentionDays: string,
	columns: Array<Column>,
	filters: Array<BoardFilter>,
	permissionLevel: number
}

export interface Column {
	id?: string,
	label?: string,
	sortOrder?: string,
	isFinal: boolean;
}

export interface ColumnStatusMap {
	columnId?: string,
	entity: string,
	statusId?: string,
	status?: string,
	default?: string,
	boardId: EntityID
}

export interface Card extends BaseEntity {
	id: string,
	entity: string
	entityId: string,
	boardId: string,
	sortOrder: number,
	columnId: string,
	responsibleUserIds: string[],
	movedAt: DateTime,
	entityData: any
}

export interface BoardFilter {
	id?: string
	boardId: EntityID,
	entity: string,
	enabled: boolean,
	parents: Array<BoardFilterParent>
}

export interface BoardFilterParent {
	filterId?: string,
	entity: string,
	entityId: string
}

export const boardDS = new JmapDataSource<Board>("Board");

export const cardDS = new JmapDataSource<Card>("Card");

export const projectbookDS = new JmapDataSource("ProjectBook");
export const taskDS = new JmapDataSource("Task");
export const tasklistDS = new JmapDataSource("TaskList");
export const supportlistDS = new JmapDataSource("SupportList");
export const ticketDS = new JmapDataSource("SupportTicket");
export const projectDS = new JmapDataSource("Project3")